// ets_tracing: off
import * as S from "@effect-ts/core/Sync";
import { interpreter } from "../../HKT/index.mjs";
import { decoderApplyConfig, DecoderType, DecoderURI } from "../base/index.mjs";
import { appendContext, failures, makeDecoder } from "../common/index.mjs";
export const decoderUnionInterpreter = /*#__PURE__*/interpreter()(() => ({
  _F: DecoderURI,
  union: (...types) => cfg => env => {
    const decoders = types.map(a => a(env));
    return new DecoderType(decoderApplyConfig(cfg === null || cfg === void 0 ? void 0 : cfg.conf)(makeDecoder((u, c) => S.gen(function* (_) {
      const errors = [];

      for (const d in decoders) {
        const res = yield* _(S.either(decoders[d].decoder.validate(u, appendContext(c, "", decoders[d].decoder, u))));

        if (res._tag === "Right") {
          return res.right;
        } else {
          errors.push(...res.left);
        }
      }

      return yield* _(failures(errors));
    }), "union", (cfg === null || cfg === void 0 ? void 0 : cfg.name) || "Union"), env, {
      decoders: decoders
    }));
  }
}));
//# sourceMappingURL=union.mjs.map